/**
 * Internal Communication - Constants & Translations
 */

export const COMMUNICATION_TRANSLATIONS = {
  en: {
    messages: 'Messages',
    newMessage: 'New Message',
    sendMessage: 'Send',
    typeMessage: 'Type your message...',
    noMessages: 'No messages yet',
    startConversation: 'Start a conversation',
    conversations: 'Conversations',
    dealChat: 'Deal Chat',
    privateChat: 'Private Chat',
    groupChat: 'Group Chat',
    internalNotes: 'Internal Notes',
    addNote: 'Add Note',
    pinNote: 'Pin Note',
    unpinNote: 'Unpin Note',
    deleteNote: 'Delete Note',
    noNotes: 'No internal notes',
    staffOnly: 'Staff Only',
    attachFile: 'Attach File',
    selectRecipient: 'Select recipient',
    selectDeal: 'Select deal',
    searchMessages: 'Search messages...',
    today: 'Today',
    yesterday: 'Yesterday',
    markAsRead: 'Mark as read',
    replyTo: 'Reply to',
    participants: 'Participants',
    addParticipant: 'Add Participant',
    leaveConversation: 'Leave Conversation',
    archiveConversation: 'Archive',
    unarchiveConversation: 'Unarchive',
    messageDelivered: 'Delivered',
    messageRead: 'Read',
    typing: 'typing...',
  },
  fr: {
    messages: 'Messages',
    newMessage: 'Nouveau Message',
    sendMessage: 'Envoyer',
    typeMessage: 'Tapez votre message...',
    noMessages: 'Aucun message',
    startConversation: 'Démarrer une conversation',
    conversations: 'Conversations',
    dealChat: 'Chat du Deal',
    privateChat: 'Chat Privé',
    groupChat: 'Chat de Groupe',
    internalNotes: 'Notes Internes',
    addNote: 'Ajouter une Note',
    pinNote: 'Épingler',
    unpinNote: 'Désépingler',
    deleteNote: 'Supprimer',
    noNotes: 'Aucune note interne',
    staffOnly: 'Staff Uniquement',
    attachFile: 'Joindre un fichier',
    selectRecipient: 'Sélectionner le destinataire',
    selectDeal: 'Sélectionner le deal',
    searchMessages: 'Rechercher des messages...',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    markAsRead: 'Marquer comme lu',
    replyTo: 'Répondre à',
    participants: 'Participants',
    addParticipant: 'Ajouter un Participant',
    leaveConversation: 'Quitter la Conversation',
    archiveConversation: 'Archiver',
    unarchiveConversation: 'Désarchiver',
    messageDelivered: 'Livré',
    messageRead: 'Lu',
    typing: 'écrit...',
  },
};

/** Hub-level translations for the Communications page */
export const COMM_HUB_T = {
  en: {
    // Sidebar nav
    inbox: 'Inbox',
    search: 'Search',
    activity: 'Activity',
    dialpad: 'Dial Pad',
    aiAgent: 'AI Agent',
    contacts: 'Contacts',
    marketing: 'Marketing',
    settings: 'Settings',
    // Tabs
    tabMessages: 'Messages',
    tabCalls: 'Calls',
    tabVoicemail: 'Voicemail',
    // Filters
    filterAll: 'All',
    filterUnread: 'Unread',
    filterAssigned: 'Assigned',
    filter: 'Filter',
    // Search
    searchConversations: 'Search conversations...',
    noConversations: 'No conversations',
    // Main area
    selectConversation: 'Select a conversation',
    selectFromLeft: 'Choose from the list on the left',
    // Thread types
    call: 'Call',
    sms: 'SMS',
    chat: 'Chat',
    // Contact panel
    contact: 'Contact',
    addName: 'Add a name...',
    callAction: 'Call',
    messageAction: 'Message',
    company: 'Company',
    role: 'Role',
    phone: 'Phone',
    email: 'Email',
    status: 'Status',
    addCompany: 'Add a company...',
    addRole: 'Add a role...',
    addEmail: 'Add an email...',
    addTag: 'Add a tag...',
    saveAsContact: 'Save as marketing contact',
    // SMS
    writeMessage: 'Write a message...',
    logContact: 'Log contact',
    smsSent: 'SMS sent',
    smsError: 'Error sending SMS',
    // Call statuses
    callCompleted: 'Call completed',
    callMissed: 'Missed call',
    ringing: 'Ringing...',
    busy: 'Busy',
    voicemailMsg: 'Voicemail',
    callPrefix: 'Call',
    duration: 'Duration',
    // Voicemail / Call detail
    voiceMessage: 'Voicemail',
    callEnded: 'Call completed',
    missedCall: 'Missed call',
    callback: 'Call back',
    transcription: 'Transcription',
    transcriptionProcessing: 'Processing transcription...',
    summaryGenerating: 'Generating call summary...',
    waitingRecording: 'Waiting for recording...',
    // Dial pad
    dialCall: 'Call',
    dialSMS: 'SMS',
    enterNumber: 'Enter a number',
    saveContact: 'Save as contact',
    recentCalls: 'Recent calls',
    noRecentCalls: 'No recent calls',
    // Meeting context
    videoConference: 'Video conference',
    phoneCall: 'Phone call',
    dial: 'Dial',
    joinVideoConference: 'Join video conference',
    noPhoneAvailable: 'No phone number available for this meeting.',
    video: 'Video',
    emailAction: 'Email',
    // Toasts
    newSmsFrom: 'New SMS from',
    messageReceived: 'Message received',
    incomingCallFrom: 'Incoming call from',
    statusLabel: 'Status',
    newVoicemailReceived: 'New voicemail received!',
    from: 'From',
    conversionUpdated: 'Conversion status updated',
    newContact: 'New contact',
    // Contacts directory
    contactBook: 'Contact book',
    newContactBtn: 'New',
    searchContacts: 'Search by name, number or company...',
    noResults: 'No results',
    noContacts: 'No contacts',
    callBtn: 'Call',
    smsBtn: 'SMS',
    // Contact statuses
    statusContacted: 'Contacted',
    statusInterested: 'Interested',
    statusMeetingScheduled: 'Meeting scheduled',
    statusConverted: 'Converted',
    statusNotInterested: 'Not interested',
    statusFollowUp: 'Follow up',
    // Edit contact
    editContact: 'Edit contact',
    firstName: 'First name',
    lastName: 'Last name',
    specialty: 'Specialty',
    conversionStatus: 'Conversion status',
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    contactUpdated: 'Contact updated',
    updateError: 'Error updating contact',
    deleteContact: 'Delete',
    deleteConfirm: 'Are you sure you want to delete',
    deleteIrreversible: 'This action cannot be undone.',
    deleteError: 'Error deleting contact',
    contactDeleted: 'Contact deleted',
  },
  fr: {
    inbox: 'Boîte de réception',
    search: 'Recherche',
    activity: 'Activité',
    dialpad: 'Clavier',
    aiAgent: 'Agent IA',
    contacts: 'Contacts',
    marketing: 'Marketing',
    settings: 'Paramètres',
    tabMessages: 'Messages',
    tabCalls: 'Appels',
    tabVoicemail: 'Vocal',
    filterAll: 'Tout',
    filterUnread: 'Non lu',
    filterAssigned: 'Assigné',
    filter: 'Filtrer',
    searchConversations: 'Rechercher des conversations...',
    noConversations: 'Aucune conversation',
    selectConversation: 'Sélectionnez une conversation',
    selectFromLeft: 'Choisissez dans la liste à gauche',
    call: 'Appel',
    sms: 'SMS',
    chat: 'Chat',
    contact: 'Contact',
    addName: 'Ajouter un nom...',
    callAction: 'Appeler',
    messageAction: 'Message',
    company: 'Entreprise',
    role: 'Rôle',
    phone: 'Téléphone',
    email: 'Courriel',
    status: 'Statut',
    addCompany: 'Ajouter une entreprise...',
    addRole: 'Ajouter un rôle...',
    addEmail: 'Ajouter un courriel...',
    addTag: 'Ajouter un tag...',
    saveAsContact: 'Enregistrer comme contact marketing',
    writeMessage: 'Écrivez un message...',
    logContact: 'Log contact',
    smsSent: 'SMS envoyé',
    smsError: "Erreur lors de l'envoi du SMS",
    callCompleted: 'Appel terminé',
    callMissed: 'Appel manqué',
    ringing: 'Sonnerie...',
    busy: 'Occupé',
    voicemailMsg: 'Message vocal',
    callPrefix: 'Appel',
    duration: 'Durée',
    voiceMessage: 'Message vocal',
    callEnded: 'Appel terminé',
    missedCall: 'Appel manqué',
    callback: 'Rappeler',
    transcription: 'Transcription',
    transcriptionProcessing: 'Transcription en cours de traitement...',
    summaryGenerating: "Génération du résumé d'appel...",
    waitingRecording: "En attente de l'enregistrement...",
    dialCall: 'Appel',
    dialSMS: 'SMS',
    enterNumber: 'Entrez un numéro',
    saveContact: 'Sauvegarder comme contact',
    recentCalls: 'Appels récents',
    noRecentCalls: 'Aucun appel récent',
    videoConference: 'Visioconférence',
    phoneCall: 'Appel téléphonique',
    dial: 'Composer',
    joinVideoConference: 'Rejoindre la visioconférence',
    noPhoneAvailable: 'Aucun numéro de téléphone disponible dans ce rendez-vous.',
    video: 'Vidéo',
    emailAction: 'Courriel',
    newSmsFrom: 'Nouveau SMS de',
    messageReceived: 'Message reçu',
    incomingCallFrom: 'Appel entrant de',
    statusLabel: 'Statut',
    newVoicemailReceived: 'Nouveau message vocal reçu !',
    from: 'De',
    conversionUpdated: 'Statut de conversion mis à jour',
    newContact: 'Nouveau contact',
    contactBook: 'Carnet de contacts',
    newContactBtn: 'Nouveau',
    searchContacts: 'Rechercher par nom, numéro ou entreprise...',
    noResults: 'Aucun résultat',
    noContacts: 'Aucun contact',
    callBtn: 'Appeler',
    smsBtn: 'SMS',
    statusContacted: 'Contacté',
    statusInterested: 'Intéressé',
    statusMeetingScheduled: 'RDV planifié',
    statusConverted: 'Converti',
    statusNotInterested: 'Non intéressé',
    statusFollowUp: 'À recontacter',
    editContact: 'Modifier le contact',
    firstName: 'Prénom',
    lastName: 'Nom',
    specialty: 'Spécialité',
    conversionStatus: 'Statut de conversion',
    save: 'Enregistrer',
    cancel: 'Annuler',
    saving: 'Enregistrement...',
    contactUpdated: 'Contact mis à jour',
    updateError: 'Erreur lors de la mise à jour',
    deleteContact: 'Supprimer',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    deleteIrreversible: 'Cette action est irréversible.',
    deleteError: 'Erreur lors de la suppression',
    contactDeleted: 'Contact supprimé',
  },
} as const;

export type CommHubKey = keyof typeof COMM_HUB_T.en;
